<div class="sidebar-wrapper pb-5">
    <div class="logo">
        <a class="simple-text logo-normal">
      Sis-G@@
    </a>
    </div>
    <app-sub-sidebar *ngFor="let menuItem of menuItems" [menu]="menuItem"></app-sub-sidebar>
</div>